import { Dialog } from '@angular/cdk/dialog';
import { CommonModule, Location } from '@angular/common';
import {
  Component, HostListener, OnDestroy, OnInit, inject,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { LanguageService, Language, PageService } from '@instaclause-webapp/shared-core';
import { InlineSvgComponent } from '@instaclause-webapp/shared-ui';
import { TranslocoModule } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

import { NewContractModelComponent } from '../../feature/contract-model/new-contract-model/new-contract-model.component';

@Component({
  selector: 'app-bottom',
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
    InlineSvgComponent,
  ],
  templateUrl: './bottom.component.html',
  styleUrl: './bottom.component.scss',
})
export class BottomComponent implements OnInit, OnDestroy {

  avalibleLanguages!: Language[];
  isHome = false;
  currentRoute!: string;
  isOpenLanguages = false;

  protected languageService = inject(LanguageService);
  private subscription = new Subscription();
  private pageService = inject(PageService);
  private location = inject(Location);
  private dialog = inject(Dialog);
  private router = inject(Router);


  @HostListener('document:click', [ '$event' ])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = (event.target as HTMLElement).closest('.bottom-language-wrapper');
    if (!clickedInside) {
      this.isOpenLanguages = false;
    }
  }

  ngOnInit(): void {
    this.avalibleLanguages = this.languageService.getAvailableLanguages();

    this.subscription = this.pageService.currentPath$.subscribe(url => {
      console.log(url);
      this.isHome = url === '/home';
      this.currentRoute = url;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onChangeLanguage(language: Language): void {
    this.languageService.changeLanguage(language);
  }

  onBack(): void {
    this.location.back();
  }

  onNewContractModel() {
    const dialogRef = this.dialog.open(NewContractModelComponent);

    dialogRef.closed.subscribe(result => {
      console.log('Dialog closed with result:', result);
      if (typeof result === 'number') {
        console.log('Reloading contract models');
        this.router.navigate([ 'editor', 'new', { contractModelId: result } ]);
      }
    });
  }

  languagePickerOpen() {
    this.isOpenLanguages = !this.isOpenLanguages;
  }
}
